import React, { useState, useEffect } from 'react'
import { Modal } from 'antd'
import { Form,Radio,App } from 'antd'  
import UserSelect from '../../user/UserSelect';
import Icon from '../../../cpn/Icon';
import { useTDspjdUpdateSaveMutation } from '../../../store/DianShangYeWuApi';
function ReportNodeEdit(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [info, setInfo] = useState({
        node_type: '审批',
        node_user_name: '',
        node_content: '',
        node_user_id: '',
    });
    const [submitEdit] = useTDspjdUpdateSaveMutation();
    useEffect(() => {
        form.setFieldsValue({
            node_type: props.dsbzd_spjd_name,
            node_user_name: props.dsbzd_spjd_yh_name,
            node_user_id: props.dsbzd_spjd_yh_id,
        });
    }, [props.dsbzd_spjd_name, props.dsbzd_spjd_yh_name, props.dsbzd_spjd_yh_id, form]);
    return (
        <>
            <Icon type='edit' onClick={() => {setOpen(true);}} title='修改审批节点'></Icon>
            <Modal 
                open={open} 
                onCancel={() => setOpen(false)}
                footer={null}
            >
                <Form 
                    form={form} 
                    initialValues={{
                        node_type: '审批',
                        node_user_name: '',
                        node_content: '',
                        node_user_id: '',
                    }}
                    labelCol={{ span: 6 }}
                >    
                    <Form.Item  
                        name="node_type" 
                        label="审批类型"
                        wrapperCol={{ span: 14 }}
                        required
                    >
                        <Radio.Group
                            onChange={(e) => {
                                setInfo(prev=>({...prev, node_type: e.target.value}))
                            }}
                            style={{ width: '170px' }}
                        >
                            <Radio value="审批">审批</Radio>
                            <Radio value="抄送">抄送</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <UserSelect 
                        labelCol={{ span: 6}}
                        label="操作员"
                        qy_id={props.qy_id}
                        onChange={(value) => {
                            console.log(value);
                            setInfo(prev=>({...prev, node_user_name: value.yh_name, node_user_id: value.yh_id}))
                        }}
                        name="node_user_id"
                        required
                        placeholder={info.node_type === '审批' ? '请选择审批人' : '请选择抄送人'}
                        disabled={info.node_type === ''}
                        wrapperCol={{ span: 14 }}
                        style={{ width: '200px' }}
                    />  
                    <Form.Item wrapperCol={{ span: 14 ,offset: 6}}>
                        <Icon 
                            type='save' 
                            onClick={() => {
                                if(!info.node_type){
                                    message.error('请选择节点类型')
                                    return;
                                }
                                if(!info.node_user_name){
                                    message.error('请选择操作员')
                                    return;
                                }
                                submitEdit({
                                    'dsbzd_spjd_qy_id': props.qy_id,
                                    'dsbzd_spjd_qy_name': props.qy_name,
                                    'dsbzd_spjd_xuhao': props.dsbzd_spjd_xuhao,
                                    'dsbzd_spjd_name': info.node_type,
                                    'dsbzd_spjd_yh_id': info.node_user_id,
                                    'dsbzd_spjd_yh_name': info.node_user_name,
                                    'dsbzd_spjd_uid': props.yh_id,
                                    'dsbzd_spjd_uname': props.yh_name,
                                    'dsbzd_spjd_content': '',
                                    'dsbzd_spjd_user_id': '1',
                                    'dsbzd_spjd_user_name': '1',
                                    'dsbzd_spjd_id': props.dsbzd_spjd_id,
                                }).then(res => {
                                    if(res.data.Status === 'success'){
                                        message.success('修改成功')
                                        setOpen(false);
                                    } else {
                                        message.error('修改失败'+res.data.Message)
                                    }
                                });
                                form.resetFields(['node_type', 'node_user_id', 'node_content']);
                                setInfo(prev => ({
                                    ...prev,
                                    node_type: '',
                                    node_user_name: '',
                                    node_content: '',
                                    node_user_id: '',
                                }));
                            }} 
                            title='修改审批节点' 
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ReportNodeEdit